module.exports = __webpack_public_path__ + "static/img/technical_support.28988789.png";